import React, { useState, useEffect, useRef } from "react"
import Grant from "./Marker/Grant"
import Charts from "./Marker/Charts"
import Actions from "./Marker/Actions"
import Header from "./Marker/Header"
import { Tab, TabList, TabPanel, Tabs } from "react-tabs"
import styles from "../Dashboard.module.css"
import { getStatusColor } from "../../../../utils/outorga/dashboard"

const MarkerPopup = ({ title, status, marker, isActive, openCalendar, grantId, idMonitorado, openFullCharts }) => {
  const [tab, setTab] = useState(0)

  const tabsConfig = [
    { title: "Outorga", component: Grant },
    { title: "Gráficos", component: Charts },
    { title: "Ações", component: Actions },
  ]

  const handleTab = (index) => {
    setTab(index)
  }

  useEffect(() => {
    if (!isActive) {
      setTab(0)
    }
  }, [isActive])

  return (
    <div className={styles.popupCard}>
      <Header title={title} status={status} />

      <Tabs
        className={styles.tabs}
        selectedIndex={tab}
        onSelect={handleTab}
      >
        <TabList
          className={styles.tabList}
          style={{ borderTopColor: getStatusColor(status) }}
        >
          {tabsConfig.map((tabItem, index) => (
            <Tab
              key={index}
              className={styles.tab}
              selectedClassName={styles.tabSelected}
              disabledClassName={styles.tabDisabled}
              disabled={tabItem.disabled}
            >
              {tabItem.title}
            </Tab>
          ))}
        </TabList>

        {tabsConfig.map((tabItem, index) => {
          const Component = tabItem.component

          return (
            <TabPanel key={index}>
              <Component
                openCalendar={openCalendar}
                grantId={grantId}
                idMonitorado={idMonitorado}
                openFullCharts={openFullCharts}
                marker={marker}
              />
            </TabPanel>
          )
        })}
      </Tabs>
    </div>
  )
}

export default MarkerPopup